// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1lPHC","footer":"ModalFilter_footer__DPsQi"};